/* unplugin-vue-components disabled */import { render } from "./user-message.vue?vue&type=template&id=e6f290f2&scoped=true"
import script from "./user-message.vue?vue&type=script&lang=js"
export * from "./user-message.vue?vue&type=script&lang=js"

import "./user-message.vue?vue&type=style&index=0&id=e6f290f2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6f290f2"],['__file',"src/components/ai-chat/user-message.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e6f290f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e6f290f2', __exports__)) {
    api.reload('e6f290f2', __exports__)
  }
  
  module.hot.accept("./user-message.vue?vue&type=template&id=e6f290f2&scoped=true", () => {
    api.rerender('e6f290f2', render)
  })

}


export default __exports__